module.exports = __webpack_public_path__ + "static/media/P1050556.06d7c46a.JPG";